import Vue from "vue";
import error from "./error.vue";
import router from "@/router/index.js";

// 组件构造器，构造出一个 vue组件实例
const ConfirmConstructor = Vue.extend(error);

function showErrorPage(options) {
  const dom = new ConfirmConstructor({
    el: document.createElement("div"),
    router,
    data() {
      return {
        ...options,
      };
    },
  });
  if (window.isElectron) {
    router.replace({
      name: "Error",
      query: {
        tips: options?.tips,
      },
    });
  } else {
    document.body.innerHTML = "";
    document.body?.appendChild(dom.$el);
  }
}

// 全局注册
export default () => {
  Vue.prototype.$showErrorPage = showErrorPage;
};
